import React from 'react';
import { Box, Typography, Stack, TextField, MenuItem, IconButton } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Currency } from "../interfaces/OperatorDashboard";

interface DashboardHeaderProps {
    currency: Currency | '';
    setCurrency: (c: Currency) => void;
    availableCurrencies: Currency[];
    isLoading: boolean;
    onRefresh: (curr: string, force: boolean) => void;
    hasData: boolean;
}

export const DashboardHeader = ({
    currency, setCurrency, availableCurrencies, isLoading, onRefresh, hasData
} : DashboardHeaderProps) => {
    return (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 4, alignItems: 'flex-end' }}>
            <Box>
                <Typography variant="h4" sx={{ fontWeight: 800 }}>Financial Dashboard</Typography>
                <Typography variant="body2" color="text.secondary">
                    Monitor Escrow and SC Wallet flows in real-time.
                </Typography>
            </Box>
            <Stack direction="row" spacing={1} alignItems="center">
                <TextField
                    size="small"
                    select
                    label="Currency"
                    value={currency}
                    onChange={e => setCurrency(e.target.value as Currency)}
                    sx={{ width: 120, bgcolor: '#fff' }}
                >
                    {availableCurrencies.map(curr => (
                        <MenuItem key={curr} value={curr}>{curr}</MenuItem>
                    ))}
                </TextField>

                <IconButton
                    onClick={() => onRefresh(currency, false)}
                    color="primary"
                    disabled={isLoading || !currency}
                    sx={{ bgcolor: 'primary.50' }}
                >
                    <SearchIcon />
                </IconButton>

                {hasData && (
                    <IconButton
                        onClick={() => onRefresh(currency, true)}
                        disabled={isLoading}
                        sx={{ bgcolor: 'grey.100' }}
                    >
                        <RefreshIcon />
                    </IconButton>
                )}
            </Stack>
        </Box>
    );
};